/**
 * @Component - DropdownItem (fds-dropdown-item)
 * @description - DropdownItem component for FormDS Web Components
 * ONLY IN USE WITHIN THE DROPDOWN COMPONENT FOR THE DEFINISTION AND PROPERTY TYPE CHECKING.
 */
import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'fds-dropdown-item',
  shadow: true,
})
export class DropdownItem {
  /**
   * The actual value of the dropdown item
   */
  @Prop() value: string;

  /**
   * If true, this item is selected
   */
  @Prop() selected: boolean;

  /**
   * Which category this dropdown item belongs to
   */
  @Prop() category: string;

  render() {
    return <Host></Host>;
  }
}
